export default "__VITE_ASSET__ZrQrFmPl__"